import { Routes, Route, Navigate } from "react-router-dom";

import {
  Auditoria,
  EstablishmentConfig,
  ListagemDeEstabelecimentos,
} from "../pages";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ListagemDeEstabelecimentos />} />

      <Route path="/auditoria" element={<Auditoria />} />
      <Route
        path="/estabelecimentos"
        element={<ListagemDeEstabelecimentos />}
      />
      <Route
        path="/estabelecimentos/configuracao/:id"
        element={<EstablishmentConfig />}
      />
      <Route
        path="/estabelecimentos/configuracao"
        element={<EstablishmentConfig />}
      />

      <Route path="/" element={<Navigate to="/estabelecimentos" />} />
      <Route path="*" element={<Navigate to="/estabelecimentos" />} />
    </Routes>
  );
};
